module.exports = __webpack_public_path__ + "img/active-10.aaab8ea2.svg";